// Scrollable variant option list: after each partial refresh (new element connects), scroll the
// list itself, never the page, so the checked value sits in view.
class SOptionList extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => {
      if (this.scrollHeight <= this.clientHeight + 1) return;
      const checked = this.querySelector('input:checked')?.closest('label');
      if (!checked) return;
      const top = checked.offsetTop;
      const bottom = top + checked.offsetHeight;
      if (top < this.scrollTop || bottom > this.scrollTop + this.clientHeight) {
        this.scrollTop = Math.max(0, top - (this.clientHeight - checked.offsetHeight) / 2);
      }
    });
  }
}

if (!customElements.get('s-option-list')) customElements.define('s-option-list', SOptionList);
